module.exports = __webpack_public_path__ + "static/media/id-card.0b9d2d68.svg";